export const stripLoginParams = (search) => {
  const params = new URLSearchParams(search);
  if (!params.has("token")) return search || "";
  ["token", "email", "ph_no"].forEach((key) => params.delete(key));
  const query = params.toString();
  return query ? `?${query}` : "";
};

// Used when another tab already logged out; storage is left as that tab set it.
export const redirectToLogin = () => {
  if (window.location.pathname.startsWith("/auth/")) return;
  if (!localStorage.getItem("LoginTag")) localStorage.setItem("LoginTag", "Email");
  window.location.replace("/auth/login");
};

// Another tab removing the token logs this tab out too.
export const watchCrossTabLogout = () => {
  let timer;
  const onStorage = (event) => {
    if (event.key !== null && event.key !== "token") return;
    if (event.newValue) return;
    clearTimeout(timer);
    // A ?token login clears storage before writing the new token; wait for it.
    timer = setTimeout(() => {
      if (!localStorage.getItem("token")) redirectToLogin();
    }, 1500);
  };
  window.addEventListener("storage", onStorage);
  return () => {
    clearTimeout(timer);
    window.removeEventListener("storage", onStorage);
  };
};

export const logoutToLogin = () => {
  localStorage.clear();
  localStorage.setItem("LoginTag", "Email");
  // Reloading a deployed tenant URL can replay its login token.
  window.location.replace("/auth/login");
};
